import { css } from '@emotion/css';

export const sectionBaca = css`
  .sekatAtas{
    height:calc(10px + 1vw);
  }

  .judulnya{
    font-family: 'Poppins', sans-serif;
    text-align: center;
    padding-bottom:calc(20px + 1vw);
  }

  .tulisanChapter{
    font-family: 'STIX Two Text', serif;
    text-indent: 20px;
    font-size: calc(15px + 0.5vw);
    line-height: 1.5;
    margin-bottom:1vw;
    text-align: justify;
  }

  .tulisanChapterTitik{
    font-family: 'STIX Two Text', serif;
    font-size: calc(15px + 0.5vw);
    line-height: 3;
    margin-bottom:1vw;
    text-align: center;
  }

  .containerTulisan{
    margin-left:6vw;
    margin-right:6vw;
    margin-top:50px;
    margin-bottom:50px;
  }

  .buatTulisan{
    border-color: #fff;
    border-style: solid;
    max-width: 100%;
    box-shadow: 0 8px 12px 10px rgb(18 18 18 / 16%);
    background-color: white;
  }
`;